import VehicleComparisonTechnicalData from "./VehicleComparisonTechnicalData";

export default VehicleComparisonTechnicalData;
